export default __webpack_public_path__ + "static/media/gallery_06.d2b4ed3d.jpg";